import { unionBy } from 'lodash';

export const unionFeatureFlip = (defaultEnv:any[]) =>
  (overideEnv = []):any[] => unionBy(overideEnv, defaultEnv, 'name');
